import React from 'react';
import { Check } from 'lucide-react';
import { usePopup } from '../context/PopupContext';

const CompanyPackages = () => {
  const { openPopup } = usePopup();

  const features = [
    "Make sure you're not liable for any business debts. Ensure you're not on the hook for business liabilities",
    "Company Formation through a Simple Process: Our 3 step process begins with entering your details, then selecting a service and lastly payment.",
    "Save Money on Taxes: For potential savings you get to decide whether you're taxed as a LLC or a Corporation"
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#C0392B] via-[#A93226] to-[#8B2E1F] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '40px 40px'}} />
      </div>

      <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Custom Company Formation Packages for Every Business
          </h2>
          <p className="text-lg text-white/90 max-w-4xl mx-auto">
            Trademark Vector offers a range of tailored packages designed for businesses of all sizes. Our affordable, all-inclusive options provide the support you need at every step of your company formation process.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            {/* Red Header with Brand Colors */}
            <div className="bg-gradient-to-r from-[#C0392B] to-[#A93226] py-12 px-8 text-center">
              <h3 className="text-3xl md:text-4xl font-bold text-white">
                START YOUR BUSINESS<br />WITH EASE
              </h3>
            </div>

            {/* White Content Area */}
            <div className="p-8 md:p-12">
              <ul className="space-y-6">
                {features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <Check className="w-6 h-6 text-[#C0392B] flex-shrink-0 mt-1 mr-4" />
                    <span className="text-[#2C3E50] text-base md:text-lg leading-relaxed">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="text-center mt-10">
                <button
                  onClick={openPopup}
                  className="bg-gradient-to-r from-[#C0392B] to-[#A93226] hover:from-[#A93226] hover:to-[#8B2E1F] text-white px-12 py-4 rounded-full text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105"
                >
                  Get Started Today
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyPackages;
